// extracted by mini-css-extract-plugin
export default {"list":"MessageOptionList_list__60-jT"};